import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  instructions: {
    id: 'components.FixedFilters.FilterProceduresHeader.instructions',
    defaultMessage: 'Search and select the CPT Code that you want to filter for.',
  },
  filteringForEmpty: {
    id: 'components.FixedFilters.FilterProceduresList.filteringForEmpty',
    defaultMessage: 'Currently filtering for none.',
  },
  filteringFor: {
    id: 'components.FixedFilters.FilterProceduresList.filteringFor',
    defaultMessage: 'Currently filtering for',
  },
  noResults: {
    id: 'components.FixedFilters.FilterProceduresList.noResults',
    defaultMessage: 'No result for this search.',
  },
});
